/** Parsiranje i zbroj sati iz dailyMetrics (Glovo + Wolt + godišnji). */

export function parseGodisnjiHours(m) {
  if (!m) return 0;
  const v = m.godisnjiHours;
  const n = typeof v === 'number' ? v : parseFloat(v);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

export function parseGlovoHours(m) {
  if (!m) return 0;
  const glovoH = m.glovoHours ?? (m.actualWorkingHours ? parseFloat(m.actualWorkingHours) : 0);
  const n = parseFloat(glovoH);
  return Number.isFinite(n) ? n : 0;
}

export function parseWoltHours(m) {
  if (!m) return 0;
  const woltH = m.woltHours ?? (m.plannedWorkingHours ? parseFloat(m.plannedWorkingHours) : 0);
  const n = parseFloat(woltH);
  return Number.isFinite(n) ? n : 0;
}

export function isGodisnjiMetric(m) {
  return parseGodisnjiHours(m) > 0;
}

/** Ukupno za dan (godišnji ILI glovo+wolt). */
export function getHoursFromMetric(m) {
  const godisnji = parseGodisnjiHours(m);
  if (godisnji > 0) return godisnji;
  return parseGlovoHours(m) + parseWoltHours(m);
}

/** Samo radni sati (bez godišnjeg) – za nedjelju/praznik kad nije godišnji. */
export function getWorkHoursFromMetric(m) {
  if (isGodisnjiMetric(m)) return 0;
  return parseGlovoHours(m) + parseWoltHours(m);
}

/**
 * Zbroj odrađenih sati u kalendarskom mjesecu (redovni + prekovremeni po danu).
 * U dailyMetrics nema zasebnih polja: sve je glovoHours + woltHours za taj dan.
 * Godišnji se ne uračunava u potrošnju redovnog mjesečnog fonda.
 */
export function sumWorkedHoursInCalendarMonth(metrics, year, month) {
  if (!Array.isArray(metrics)) return 0;
  return metrics
    .filter((d) => d.year === year && d.month === month)
    .reduce((sum, d) => sum + getWorkHoursFromMetric(d), 0);
}
